import { render, staticRenderFns } from "./myReward.vue?vue&type=template&id=643510db&scoped=true&"
import script from "./myReward.vue?vue&type=script&lang=ts&"
export * from "./myReward.vue?vue&type=script&lang=ts&"
import style0 from "./myReward.vue?vue&type=style&index=0&id=643510db&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643510db",
  null
  
)

export default component.exports